import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createMachineGroup } from "@/api/machine-group-api";
import { type CreateMachineGroup } from "@/schemas/machine-group";

import { MACHINE_GROUPS_QUERY_KEY } from "./use-machine-groups";

export const useCreateMachineGroup = () => {
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: (data: CreateMachineGroup) => createMachineGroup(data),
		onSuccess: async () => {
			await queryClient.refetchQueries({ queryKey: MACHINE_GROUPS_QUERY_KEY });
		},
	});

	return {
		mutate: mutation.mutateAsync,
		isPending: mutation.isPending,
		isSuccess: mutation.isSuccess,
		isError: mutation.isError,
		error: mutation.error,
	};
};
